// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Code = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Code = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Code = _exports.Code = function Code(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.1138 2.95187C12.5546 3.08412 12.8048 3.54869 12.6725 3.98951L8.92254 16.4895C8.79029 16.9303 8.32572 17.1805 7.88489 17.0482C7.44407 16.916 7.19391 16.4514 7.32616 16.0106L11.0762 3.5106C11.2084 3.06977 11.673 2.81962 12.1138 2.95187ZM6.8765 5.0763C7.17956 5.42267 7.14447 5.94914 6.7981 6.2522L2.51484 10.0001L6.7981 13.7479C7.14447 14.051 7.17956 14.5774 6.8765 14.9238C6.57343 15.2702 6.04696 15.3053 5.7006 15.0022L0.700595 10.6272C0.519749 10.469 0.416016 10.2404 0.416016 10.0001C0.416016 9.75975 0.519749 9.53115 0.700595 9.37291L5.7006 4.99791C6.04696 4.69484 6.57343 4.72994 6.8765 5.0763ZM13.1222 5.0763C13.4253 4.72994 13.9517 4.69484 14.2981 4.99791L19.2981 9.37291C19.4789 9.53115 19.5827 9.75975 19.5827 10.0001C19.5827 10.2404 19.4789 10.469 19.2981 10.6272L14.2981 15.0022C13.9517 15.3053 13.4253 15.2702 13.1222 14.9238C12.8191 14.5774 12.8542 14.051 13.2006 13.7479L17.4839 10.0001L13.2006 6.2522C12.8542 5.94914 12.8191 5.42267 13.1222 5.0763Z",
      fill: "currentColor"
    }));
  };
});
